angular.module('app.directives').directive('broadcasterGraph', ($timeout, $window, StatsService) =>
    ({
        restrict: 'E',
        scope: {
            streamId: '@',
            startsAt: '@',
            stopsAt: '@'
        },
        controller($scope) {
            $scope.timeoutId = null;
            $scope.hovering = false;
            $scope.statsData = null;
            $scope.memoryUsageOptions = {
                renderer: 'multi',
                height: 50,
                min: 0,
                padding: {
                  top: 0.10
                }
            };
            $scope.memoryUsageSeries = [{
                name: 'usage',
                renderer: 'area',
                data: [],
                color: '#5e9d2f'
            }];
            $scope.cpuUsageOptions = {
                renderer: 'multi',
                height: 50,
                min: 0,
                max: 100
            };
            $scope.cpuUsageSeries = [{
                name: 'usage',
                renderer: 'area',
                data: [],
                color: '#73c03a'
            }];
            $scope.diskUsageOptions = {
                renderer: 'multi',
                height: 50,
                min: 0,
                max: 100
            };
            $scope.diskUsageSeries = [{
                name: 'usage',
                renderer: 'area',
                data: [],
                color: '#4682b4'
            }];
            $scope.batteryLevelOptions = {
                renderer: 'multi',
                height: 50,
                min: 0,
                max: 100
            };
            $scope.batteryLevelSeries = [{
                name: 'level',
                renderer: 'area',
                data: [],
                color: '#7bc3b8'
            }];
            $scope.networkOptions = {
                renderer: 'multi',
                height: 50,
                min: 0
            };
            $scope.networkSeries = [{
                name: 'type',
                renderer: 'area',
                data: [],
                color: '#a47493'
            }];
            $scope.captureDeviceSystemPressureLevelOptions = {
                renderer: 'multi',
                height: 50,
                min: 0,
                max: 5
            };
            $scope.captureDeviceSystemPressureLevelSeries = [{
                name: 'pressure',
                renderer: 'area',
                data: [],
                color: '#446E70'
            }];
            $scope.videoBitrateOptions = {
                renderer: 'multi',
                height: 50,
                min: 0,
                padding: {
                  top: 0.10
                }
            };
            $scope.videoBitrateSeries = [{
                name: 'target',
                renderer: 'line',
                data: [],
                color: 'rgba(200,9,62,0.3)'
            },{
                name: 'actual',
                renderer: 'line',
                data: [],
                color: 'rgba(200,9,62,1)'
            }];
            $scope.audioBitrateOptions = {
                renderer: 'multi',
                height: 50,
                min: 0,
                padding: {
                  top: 0.10
                }
            };
            $scope.audioBitrateSeries = [{
                name: 'target',
                renderer: 'line',
                data: [],
                color: 'rgba(9,67,200,0.3)'
            },{
                name: 'actual',
                renderer: 'line',
                data: [],
                color: 'rgba(9,67,200,1)'
            }];

            // This data represents the individual stats for the specific time being shown.
            $scope.statsAtTime = {
                time: null,
                video: {},
                audio: {},
                battery: {},
                memory: {},
                disk: {},
                cpu: {},
                networkType: null,
                captureDeviceSystemPressureLevel: null
            };

            return $scope.$on('$destroy', function() {
                if ($scope.timeoutId != null) {
                    return $timeout.cancel($scope.timeoutId);
                }
            });
        },

        link(scope, element, attrs) {
            // Convenience method to get stats values from one or more keys
            let statsForTime = (keys, time) =>
                _.map(keys, k => (scope.statsData[k] || {})[time]).reduce(function(a, b) {
                    if (((a === null) || (a === undefined) || (a < 0)) && ((b === null) || (b === undefined) || (b < 0))) {
                        return null;
                    } else if (((a !== null) && (a !== undefined) && (a >= 0)) && ((b === null) || (b === undefined) || (b < 0))) {
                        return a;
                    } else if (((a === null) || (a === undefined) || (a < 0)) && ((b !== null) && (b !== undefined) && (b >= 0))) {
                        return b;
                    } else {
                        return a + b;
                    }
                });

            // This function is a common function to show the BoxCaster stats for a specific moment in
            // time, based on either hovering over the chart, or showing the latest value.
            //
            // The 'pct' parameter should be a float value between 0 and 1 (inclusive) representing
            // where, in the time window, data values should be shown.
            let showGraphStats = function(pct) {
                // Update the time we're showing based on pct.
                let times = _.keys(scope.statsData[_.keys(scope.statsData)[0]]);
                times.sort((a, b) => a - b);
                let time = times[Math.round(pct * (times.length - 1))];
                scope.statsAtTime.time = time;

                // This block of code pulls out all the individual stats that are used below in the
                // templates. Most of these are numeric, but some are converted to boolean.
                scope.statsAtTime.battery.level = statsForTime(['battery-level'], time);
                scope.statsAtTime.memory.usage = statsForTime(['memory-usage'], time);
                scope.statsAtTime.disk.usage = statsForTime(['disk-usage'], time);
                scope.statsAtTime.cpu.usage = statsForTime(['cpu-usage'], time);
                scope.statsAtTime.networkType = statsForTime(['network-type'], time);
                if (scope.statsAtTime.networkType != null) {
                    let statusMap = {
                        [0]: 'Cellular',
                        [1]: 'Wi-Fi'
                    };
                    scope.statsAtTime.networkType = statusMap[scope.statsAtTime.networkType];
                }
                scope.statsAtTime.captureDeviceSystemPressureLevel = statsForTime(['system-pressure'], time);
                if (scope.statsAtTime.captureDeviceSystemPressureLevel != null) {
                    let pressureLevelMap = {
                        [0]: 'Nominal',
                        [1]: 'Fair',
                        [2]: 'Serious',
                        [3]: 'Critical',
                        [4]: 'Shutdown'
                    };
                    scope.statsAtTime.captureDeviceSystemPressureLevel = pressureLevelMap[scope.statsAtTime.captureDeviceSystemPressureLevel];
                }
                scope.statsAtTime.video.target = statsForTime(['target-video-bitrate'], time);
                scope.statsAtTime.video.actual = statsForTime(['actual-video-bitrate'], time);
                scope.statsAtTime.audio.target = statsForTime(['target-audio-bitrate'], time);
                return scope.statsAtTime.audio.actual = statsForTime(['actual-audio-bitrate'], time);
            };

            // This function calculates the extents of the embedded graph area.
            let getGraphExtents = function() {
                let graphExtents = angular.copy($(element).find('td .rickshaw_graph').position());
                graphExtents.width = $(element).find('td .rickshaw_graph').width();
                graphExtents.height = $(element).find('table').height();
                return graphExtents;
            };

            // This function is called whenever the graph is hovered over (when the mouse enters or moves
            // over the graph area).
            let onGraphHoverEnter = evt =>
                scope.$apply(function() {
                    let graphExtents = getGraphExtents();
                    let offset_left = $(evt.currentTarget).parents('broadcaster-graph').offset().left;
                    $(element).find('#cursor').css('left', `${evt.clientX - offset_left - 2}px`);
                    let left = evt.clientX - $(evt.currentTarget)[0].getBoundingClientRect().left;
                    $(element).find('#cursor').show();
                    let pct = (left * 1.0) / graphExtents.width;
                    if ((pct != null) && (pct >= 0.0) && (pct <= 1.0)) {
                        showGraphStats(pct);
                        return scope.hovering = true;
                    }
                });

            // This function is called whenever the mouse leaves the graph area.
            let onGraphHoverExit = evt =>
                scope.$apply(function() {
                    $(element).find('#cursor').hide();
                    showGraphStats(1.0);
                    return scope.hovering = false;
                });

            $(element).find('td.boxcaster-diagnostic-graph-cell').hover(onGraphHoverEnter, onGraphHoverExit);
            $(element).find('td.boxcaster-diagnostic-graph-cell').mousemove(onGraphHoverEnter);

            // The following keys are data that will be retrieved for display.
            scope.keys = [
                { field: 'mean("level") * 100', value: 'broadcaster.battery', as: 'battery-level' },
                { field: 'mean("resident")', value: 'broadcaster.memory', as: 'memory-usage' },
                { field: '(mean("system") + mean("user")) * 100', value: 'broadcaster.cpu', as: 'cpu-usage' },
                { field: 'mean("used") / mean("total") * 100', value: 'broadcaster.disk', as: 'disk-usage' },
                { field: 'last("wifi")', value: 'broadcaster.network', as: 'network-type' },
                { field: 'max("system_pressure_state_level")', value: 'broadcaster.capture_device', as: 'system-pressure' },
                { field: 'mean(value)', value: 'broadcaster.target-video-bitrate', as: 'target-video-bitrate' },
                { field: 'mean(value)', value: 'broadcaster.actual-video-bitrate', as: 'actual-video-bitrate' },
                { field: 'mean(value)', value: 'broadcaster.target-audio-bitrate', as: 'target-audio-bitrate' },
                { field: 'mean(value)', value: 'broadcaster.actual-audio-bitrate', as: 'actual-audio-bitrate' },
            ];
            let startsAtDate = new Date(Date.parse(scope.startsAt));
            let stopsAtDate = new Date(Date.parse(scope.stopsAt));

            // This function will be periodically called to refresh stats data.
            var refreshFn = function() {
                let req_params = { stream: scope.streamId, time: [`time > ${startsAtDate.getTime() / 1000}s`], targets: scope.keys };
                if (stopsAtDate.getTime() < Date.now()) {
                    req_params.time.push(`time < ${stopsAtDate.getTime() / 1000}s`);
                }
                let request = StatsService.fetch(req_params);
                return request.then(function(data) {
                    scope.statsData = data;
                    if (((new Date()) - (new Date(scope.stopsAt))) < (60 * 60 * 1000)) {
                        return scope.timeoutId = $timeout(refreshFn, 10000);
                    } else {
                        return scope.timeoutId = null;
                    }
                });
            };
            refreshFn();

            // When the window is resized, we need to manually update the child graphs' sizes, since
            // Rickshaw uses SVG, and the SVG elements themselves are particularly bad about sizing.
            angular.element($window).bind('resize', function() {
                // The actual graph width is the panel width minus the width of the first and last columns.
                let panelWidth = $(element).find('#backhaul-chart-panel')[0].getBoundingClientRect().width;
                let prevColWidth = $(element).find('#backhaul-chart-panel table tr th')[0].getBoundingClientRect().width;
                let nextColWidth = $(element).find('#backhaul-chart-panel table tr td')[1].getBoundingClientRect().width;
                let newWidth = panelWidth - prevColWidth - nextColWidth;
                return scope.$apply(function() {
                    scope.videoBitrateOptions.width = newWidth;
                    scope.audioBitrateOptions.width = newWidth;
                    scope.batteryLevelOptions.width = newWidth;
                    scope.memoryUsageOptions.width = newWidth;
                    scope.diskUsageOptions.width = newWidth;
                    scope.cpuUsageOptions.width = newWidth;
                    return scope.networkOptions.width = newWidth;
                });
            });

            element.on('$destroy', function() {
                if (scope.timeoutId != null) {
                    return $timeout.cancel(scope.timeoutId);
                }
            });

            let FILTER_COUNTER_ERROR_PERCENT = 5.0;
            return scope.$watch('statsData', function(newval, oldval) {
                if (newval != null) {
                    _.each(newval, function(values, key) {
                        if (key.match(/\.buffers/) || key.match(/\.byte-count/)) {
                            let times = _.keys(values).sort();
                            let tofix = {};
                            _.each(times, function(t, i) {
                                if ((i > 0) && (i < (times.length - 1))) {
                                    let prev = values[times[i - 1]];
                                    let val = values[t];
                                    let next = values[times[i + 1]];
                                    if ((prev !== 0) && (val === 0) && (next !== 0)) {
                                        if ((Math.abs((next * 2.0) - prev) / prev) < (FILTER_COUNTER_ERROR_PERCENT / 100.0)) { //prev =~= next * 2.0
                                            values[t] = prev / 2.0;
                                            return tofix[times[i - 1]] = values[t];
                                        } else if ((Math.abs((prev * 2.0) - next) / next) < (FILTER_COUNTER_ERROR_PERCENT / 100.0)) { //next =~= prev * 2.0
                                            values[t] = next / 2.0;
                                            return tofix[times[i + 1]] = values[t];
                                        }
                                    }
                                }
                            });
                            return _.each(tofix, (v, k) => values[k] = v);
                        } else {
                            // Remove nulls from gauges
                            return _.each(values, function(v, k) {
                                if (v == null) {
                                    return delete values[k];
                                }
                            });
                        }
                    });

                    let all_times = _.union.apply(this, _.map(_.keys(newval), k => _.keys(newval[k]))).sort((a, b) => a - b);
                    _.each(_.keys(newval), function(k) {
                        let lastValue = null;
                        return _.each(all_times, function(t) {
                            if (!_.has(newval[k], t)) {
                                newval[k][t] = lastValue || 0;
                            }
                            return lastValue = newval[k][t];
                        });
                    });

                    scope.batteryLevelSeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.batteryLevelSeries[0].data, _.map(newval['battery-level'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.memoryUsageSeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.memoryUsageSeries[0].data, _.map(newval['memory-usage'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.cpuUsageSeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.cpuUsageSeries[0].data, _.map(newval['cpu-usage'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.diskUsageSeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.diskUsageSeries[0].data, _.map(newval['disk-usage'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.networkSeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.networkSeries[0].data, _.map(newval['network-type'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.captureDeviceSystemPressureLevelSeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.captureDeviceSystemPressureLevelSeries[0].data, _.map(newval['system-pressure'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.videoBitrateSeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.videoBitrateSeries[0].data, _.map(newval['target-video-bitrate'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.videoBitrateSeries[1].data.length = 0;
                    Array.prototype.push.apply(scope.videoBitrateSeries[1].data, _.map(newval['actual-video-bitrate'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.audioBitrateSeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.audioBitrateSeries[0].data, _.map(newval['target-audio-bitrate'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.audioBitrateSeries[1].data.length = 0;
                    Array.prototype.push.apply(scope.audioBitrateSeries[1].data, _.map(newval['actual-audio-bitrate'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));

                    if (!scope.hovering) { return showGraphStats(1.0); }
                }
            });
        },

        template: `
                <div class="panel panel-default">
                    <div class="panel-heading">
                    Broadcaster <span ng-show="!!statsAtTime.time">&mdash; At {{ statsAtTime.time * 1000 | timestamp }}</span>
                    </div>
                    <div class="panel-body" id="broadcaster-chart-panel" style="padding: 0px; position: relative;">
                    <table class="table" style="width: 100%; margin: 0px;">
                        <tr class="boxcaster-diagnostic-graph-row">
                            <th class="boxcaster-diagnostic-graph-rowhead">Video Bit Rate</th>
                            <td class="boxcaster-diagnostic-graph-cell">
                                <app-rickshaw rickshaw-options="videoBitrateOptions" rickshaw-series="videoBitrateSeries"></app-rickshaw>
                            </td>
                            <td>
                                <div class="boxcaster-diagnostic-graph-value" style="width:150px">Target: {{ statsAtTime.video.target | metricPrefix:'bps' }}<br/>Actual: {{ statsAtTime.video.actual | metricPrefix:'bps' }}</div>
                            </td>
                        </tr>
                        <tr class="boxcaster-diagnostic-graph-row">
                            <th class="boxcaster-diagnostic-graph-rowhead">Audio Bit Rate</th>
                            <td class="boxcaster-diagnostic-graph-cell">
                                <app-rickshaw rickshaw-options="audioBitrateOptions" rickshaw-series="audioBitrateSeries"></app-rickshaw>
                            </td>
                            <td>
                                <div class="boxcaster-diagnostic-graph-value" style="width:150px">Target: {{ statsAtTime.audio.target | metricPrefix:'bps' }}<br/>Actual: {{ statsAtTime.audio.actual | metricPrefix:'bps' }}</div>
                            </td>
                        </tr>
                        <tr class="boxcaster-diagnostic-graph-row">
                            <th class="boxcaster-diagnostic-graph-rowhead">Battery Level</th>
                            <td class="boxcaster-diagnostic-graph-cell">
                                <app-rickshaw rickshaw-options="batteryLevelOptions" rickshaw-series="batteryLevelSeries"></app-rickshaw>
                            </td>
                            <td>
                                <div class="boxcaster-diagnostic-graph-value" style="width:150px">{{ statsAtTime.battery.level | numberWithUnit:1:'%' }}</div>
                            </td>
                        </tr>
                        <tr class="boxcaster-diagnostic-graph-row">
                            <th class="boxcaster-diagnostic-graph-rowhead">Memory Usage</th>
                            <td class="boxcaster-diagnostic-graph-cell">
                                <app-rickshaw rickshaw-options="memoryUsageOptions" rickshaw-series="memoryUsageSeries"></app-rickshaw>
                            </td>
                            <td>
                                <div class="boxcaster-diagnostic-graph-value" style="width:150px">{{ statsAtTime.memory.usage | metricPrefix:'MB' }}</div>
                            </td>
                        </tr>
                        <tr class="boxcaster-diagnostic-graph-row">
                            <th class="boxcaster-diagnostic-graph-rowhead">CPU Usage</th>
                            <td class="boxcaster-diagnostic-graph-cell">
                                <app-rickshaw rickshaw-options="cpuUsageOptions" rickshaw-series="cpuUsageSeries"></app-rickshaw>
                            </td>
                            <td>
                                <div class="boxcaster-diagnostic-graph-value" style="width:150px">{{ statsAtTime.cpu.usage | numberWithUnit:1:'%' }}</div>
                            </td>
                        </tr>
                        <tr class="boxcaster-diagnostic-graph-row">
                            <th class="boxcaster-diagnostic-graph-rowhead">Disk Space</th>
                            <td class="boxcaster-diagnostic-graph-cell">
                                <app-rickshaw rickshaw-options="diskUsageOptions" rickshaw-series="diskUsageSeries"></app-rickshaw>
                            </td>
                            <td>
                                <div class="boxcaster-diagnostic-graph-value" style="width:150px">{{ statsAtTime.disk.usage | numberWithUnit:1:'%' }}</div>
                            </td>
                        </tr>
                        <tr class="boxcaster-diagnostic-graph-row">
                            <th class="boxcaster-diagnostic-graph-rowhead">Network Type</th>
                            <td class="boxcaster-diagnostic-graph-cell">
                                <app-rickshaw rickshaw-options="networkOptions" rickshaw-series="networkSeries"></app-rickshaw>
                            </td>
                            <td>
                                <div class="boxcaster-diagnostic-graph-value" style="width:150px">{{ statsAtTime.networkType }}</div>
                            </td>
                        </tr>
                        <tr class="boxcaster-diagnostic-graph-row">
                            <th class="boxcaster-diagnostic-graph-rowhead">System Pressure</th>
                            <td class="boxcaster-diagnostic-graph-cell">
                                <app-rickshaw rickshaw-options="captureDeviceSystemPressureLevelOptions" rickshaw-series="captureDeviceSystemPressureLevelSeries"></app-rickshaw>
                            </td>
                            <td>
                                <div class="boxcaster-diagnostic-graph-value" style="width:150px">{{ statsAtTime.captureDeviceSystemPressureLevel }}</div>
                            </td>
                        </tr>
                    </table>
                    <div id="cursor" class="cursor"></div>
                    </div>
                </div>
                `
    }));



// WEBPACK FOOTER //
// ./directives/broadcaster_graph.js